import { createActionHelpers } from 'vuex-loading';
const Laroute = require('../../laroute');

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    metadataList: [],
};

const mutations = {
    SET_METADATA_LIST(state, metadata) {
        if (Array.isArray(metadata)) {
            state.metadataList = metadata.map(item => ({
                id: item.id || null,
                key: item.key,
                value: item.value,
            }));
        } else {
            state.metadataList = [];
        }
    },
};

const getters = {
    metadata: state => state.metadataList,
    loading: (state, getters, rootState) =>
        rootState.loading['fetch-metadata'] || false,
    saving: (state, getters, rootState) =>
        rootState.loading['save-metadata'] || false,
};

const actions = {
    async fetchMetadata({ commit, dispatch }, { id = null } = {}) {
        const route = Laroute.route('franchise.outlet.getmetas', {
            id: id,
        });
        startLoading(dispatch, 'fetch-metadata');
        try {
            const res = await axios.get(route);
            const metadataArray = res.data.data || res.data;
            commit('SET_METADATA_LIST', metadataArray);
            return res.data;
        } catch (error) {
            console.error('Error fetching metadata:', error);
            commit('SET_METADATA_LIST', []);
            throw error;
        } finally {
            endLoading(dispatch, 'fetch-metadata');
        }
    },
    async saveMetadata({ commit, dispatch }, { id = null, metadata } = {}) {
        const route = Laroute.route('franchise.outlet.updatemetadata', {
            id: id,
        });
        startLoading(dispatch, 'save-metadata');
        try {
            const res = await axios.put(route, {
                metadata,
            });
            const updatedMetadata = res.data.data;
            commit('SET_METADATA_LIST', updatedMetadata);
            return res.data;
        } catch (error) {
            console.error('Error saving metadata:', error);
            throw error;
        } finally {
            endLoading(dispatch, 'save-metadata');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/metadata.js